<template>
    <div class="relative">
      <carousel v-if="featuredCategories.length" class="home-carousel" :options="slickOptions"
        @afterChange="handleAfterChange">
        <span v-for="(featuredCategory, i) in featuredCategories" :key="featuredCategory.title + i" @click="goToCategory(featuredCategory)">
            <img :src="featuredCategory.imageUrl" :alt="featuredCategory.title" class="tixstock-featured-img"/>
        </span>
      </carousel>
      
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { FETCH_PROPERTY_TYPE } from '../../store/actions.type';
import Preloader from '../General/Preloader.vue';
import carousel from 'vue-slick';
export default {
  components: {
    Preloader,
    carousel,
  },

  data() {
    return {
   
      isMobile: false,
      isTab: false,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        lazyLoad: 'ondemand',
        infinite: false,
        autoplaySpeed: 2000,
        dots: false,
        draggable: true,
        arrows: true,
        prevArrow: "<i class='fas fa-arrow-left d-none'></i>",
        nextArrow: "<i class='fas fa-arrow-right'></i>",
      },
    };
  },
  computed: {
    ...mapGetters(['featuredCategories']),
  },
  mounted() {
    this.handleAfterChange(event, carousel);
    this.isMobile = window.innerWidth < 768;
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth < 768;
    });
    this.isTab = window.innerWidth < 991;
    window.addEventListener("resize", () => {
      this.isTab = window.innerWidth < 991;
    });
  },
  methods: {
     goToCategory(category) {
      if (!category.slug) return;
      this.$router.push(`/international/event/${category._id}`);
    },
    handleAfterChange(event, slick, currentSlide) {
      if (currentSlide > 0) {
        slick.$prevArrow.removeClass('d-none');
        slick.$prevArrow.addClass('d-block');
      }
      if (slick.currentSlide === 0) {
        slick.$prevArrow.addClass('d-none');
        slick.$prevArrow.removeClass('d-block');
      }
    },
    
  },
};
</script>

<style lang="scss">
.tixstock-featured-img {
  width: 100%;
  height: auto;
  border-radius: 8px !important;
  height: 180px;
  object-fit: cover;
  object-position: top;
}
.home-carousel {
  .slick-arrow {
    top: calc(50% - 20px);
  }

}
$breakpoint-tablet: 575px;
@media (max-width: $breakpoint-tablet) {
  .property-carousel {
    .slick-list {
      padding: 0 0 0 0 !important;
    }
  }
}
</style>
